export default __webpack_public_path__ + "static/media/earth-loader.44d1718a.gif";